/*  MUI  */
import { Chip, Typography } from '@mui/material';

/*  React  */
import React from 'react';

export const TagChip = ({
    name,
    color = 'tag.option1',
    additionalSxStyles = {},
    'data-testid': dataTestId
}) => (
    <Chip
        data-testid={dataTestId}
        label={<Typography>{name}</Typography>}
        size="small"
        variant="whiteText"
        sx={{
            '& .MuiChip-label': {
                paddingX: '8px',
                paddingY: '2px'
            },
            backgroundColor: color,
            marginRight: '4px',
            ...additionalSxStyles
        }}
    />
);
